jQuery( function theDormitorios($){

    const $dormitorio = $('.js-dormitorio');
    const $planos_selector = $('.js-filtros__btn');
    const $planos_section = $('#section-planos');

    if( !$planos_section.length ) {
        return;
    }

    $dormitorio.addClass('interactive');

    $dormitorio.each(function(i,el){
        const $one_dormi = $(el);

        $one_dormi.on('click', function(){
            goTo( i ) ;
        })

    });

    function goTo( i ) {
        $planos_selector.eq(i).click();
        $('html, body').stop().animate({
            scrollTop: $planos_section.offset().top - 130
        }, 700);
    }

});